// extracted by mini-css-extract-plugin
module.exports = {"sectionMtc":"Mtc-module--sectionMtc--2xaPo"};